import Vue from 'vue'

export const diacriticSpaceSensitiveRegex = (string = '') => {
  return new RegExp(
    string
      .toLowerCase()
      .replace(/[aáàã]/g, '[aáàã]')
      .replace(/[eé]/g, '[eé]')
      .replace(/[ií]/g, '[ií]')
      .replace(/[oó]/g, '[oó]')
      .replace(/[uú]/g, '[uú]')
      .replace(/[cç]/g, '[cç]')
      .replace(/[\s\-_]/g, '[\\s\\-\\_]')
      .replace(/%/g, '.*'),
    'ig'
  )
}

export const getPagePermissions = (page, userPermissionsMethods, plataformModulesMethod) => {
  const loggedUser = Vue.getLoggedUser()

  const verifyFranchisee = page?.franchiseeVerification ? loggedUser.is_franchisee : false
  const verifyPiiAccess = page?.hasPiiAccessVerification ? Vue.hasPiiAccess() : true
  const verifyPiiEmployeesAccess = page?.hasPiiEmployeesAccessVerification ? Vue.hasPiiEmployeesAccess() : true

  let verifyFranchise = false
  if (page.route === '/configuracoes/permissionamento-filiado') {
    verifyFranchise = !loggedUser.is_franchise
  } else {
    verifyFranchise = page?.franchiseVerification ? loggedUser.is_franchise : false
  }

  let verifyPermission = true
  if (page.permission.length > 0 && typeof page.permission === 'object') {
    page.permission.map((permission) => {
      verifyPermission = userPermissionsMethods.havePagePermission(permission) || false
    })
  } else {
    verifyPermission = page.permission.length > 0 ? userPermissionsMethods.havePagePermission(page.permission) : true
  }

  let verifyModule = true
  if (page.allowedModule.length > 0 && typeof page.allowedModule === 'object') {
    if (page.isAlternative) {
      verifyModule = page.allowedModule.some((allowed) => plataformModulesMethod()[allowed])
    } else {
      verifyModule = page.allowedModule.every((allowed) => plataformModulesMethod()[allowed])
    }
  } else {
    if (page.route === '/clientes/interesses') {
      verifyModule = !plataformModulesMethod()[page.allowedModule]
    } else {
      verifyModule = page.allowedModule.length > 0 ? plataformModulesMethod()[page.allowedModule] : true
    }
  }

  return verifyPermission && verifyModule && !verifyFranchisee && !verifyFranchise && verifyPiiAccess && verifyPiiEmployeesAccess
}

export const search = (value, userPermissionsMethods, plataformModulesMethod) => {
  const loggedUser = Vue.getLoggedUser()

  const searchRegex = diacriticSpaceSensitiveRegex(value)
  const modules = JSON.parse(JSON.stringify(searchModules))
  let results = []
  const keys = Object.keys(modules)
  keys.map((key) => {
    let pages = modules[key].pages
    const verifyOnlyMercapromo = modules[key].onlyMercapromo ? loggedUser.only_mercapromo : false
    pages = pages.filter((page) => {
      return (
        (page.page.match(searchRegex) || page.description.match(searchRegex) || key.match(searchRegex)) &&
        getPagePermissions(page, userPermissionsMethods, plataformModulesMethod) &&
        !verifyOnlyMercapromo
      )
    })
    let temp = modules[key]
    temp.pages = pages
    results.push(temp)
  })

  return results
}

export const searchModules = {
  home: {
    name: 'Home',
    icon: 'home',
    parentPermission: '',
    pages: [
      {
        page: '',
        description: 'Página inicial da plataforma',
        route: '/home',
        permission: 'home',
        allowedModule: '',
      },
    ],
  },
  empresa: {
    name: 'Empresa',
    icon: 'work',
    parentPermission: 'empresa',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Decomposição de faturamento',
        description: 'Comparativo de métricas de faturamento entre períodos',
        route: '/empresa/decomposicao',
        permission: 'empresa/decomposicao',
        allowedModule: '',
      },
      {
        page: 'Faturamento',
        description: 'Histórico do faturamento mensal',
        route: '/empresa/faturamento',
        permission: 'empresa/faturamento',
        allowedModule: '',
      },
      {
        page: 'Desempenho',
        description: 'Histórico mensal de métricas gerais',
        route: '/empresa/desempenho',
        permission: 'empresa/desempenho',
        allowedModule: '',
      },
      {
        page: 'Faturamento incremental',
        description: 'Análise do Faturamento incremental',
        route: '/empresa/faturamento-incremental',
        permission: 'empresa/faturamento',
        allowedModule: 'offer_management',
      },
    ],
  },
  clube: {
    name: 'Clube',
    icon: 'favorite',
    parentPermission: 'clube',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Dashboard',
        description: 'Métricas gerais do clube',
        route: '/clube/dashboard',
        permission: 'clube/dashboard',
        allowedModule: '',
      },
      {
        page: 'Desempenho',
        description: 'Histórico de métricas gerais do clube',
        route: '/clube/desempenho',
        permission: 'clube/desempenho',
        allowedModule: '',
      },
      {
        page: 'Comparativo',
        description: 'Comparativo de métricas Clube x Fora clube',
        route: '/clube/comparativo',
        permission: 'clube/comparativo',
        allowedModule: '',
      },
      {
        page: 'Lojas',
        description: 'Métricas do clube separadas por loja',
        route: '/clube/lojas',
        permission: 'clube/lojas',
        allowedModule: '',
      },
      {
        page: 'Performance Operacional',
        description: 'Dados dos operadores das lojas',
        route: '/clube/performance-operacional',
        permission: 'clube/performance_operacional',
        allowedModule: 'operational_performance',
        hasPiiEmployeesAccessVerification: true,
      },
    ],
  },
  maria: {
    name: 'Mar.ia',
    icon: 'maria',
    parentPermission: '',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Previsão de vendas clube',
        description: 'Previsão de vendas de produtos no clube',
        route: '/maria/quando-vou-vender',
        permission: 'maria/quando-vou-vender',
        allowedModule: '',
      },
      {
        page: 'Campanha da Mar.ia',
        description: 'Configuração das campanhas multicanais da Mar.ia',
        route: '/maria/campanha-da-maria',
        permission: 'maria/campanha-da-maria',
        allowedModule: '',
      },
      {
        page: 'Produtos impulsionadores',
        description: 'Estratégia de impulsionamento para produtos selecionados',
        route: '/maria/produtos-impulsionadores',
        permission: 'maria/produtos-impulsionadores',
        allowedModule: '',
      },
    ],
  },
  industria: {
    name: 'Indústria',
    icon: 'currency_exchange',
    parentPermission: 'industria',
    pages: [
      {
        page: 'Resultados gerais',
        description: 'Resumo geral de ofertas da indústria e reembolso',
        route: '/industria/resultados-gerais',
        permission: '',
        allowedModule: 'industry',
      },
      {
        page: 'Ofertas de trade',
        description: 'Propostas e histórico de ofertas da indústria',
        route: '/industria/ofertas-trade',
        permission: 'industria/ofertas_trade',
        allowedModule: 'industry',
      },
      {
        page: 'SMS de trade',
        description: 'Disparos de SMS de ofertas da indústria',
        route: '/industria/sms-trade',
        permission: 'industria/sms_trade',
        allowedModule: 'industry',
      },
      {
        page: 'Cashback de trade',
        description: 'Desbloqueio de cashback de ofertas da indústria',
        route: '/industria/cashback-trade',
        permission: 'industria/cashback_trade',
        allowedModule: '',
      },
    ],
  },
  clientes: {
    name: 'Clientes',
    icon: 'group',
    parentPermission: 'clientes',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Segmentação',
        description: 'Criação e edição de segmentação de clientes',
        route: '/clientes/segmentacao',
        permission: 'clientes/segmentacao',
        allowedModule: '',
      },
      {
        page: 'Perfil demográfico',
        description: 'Divisão da base em dados demográficos',
        route: '/clientes/perfil-demografico',
        permission: 'clientes/perfil_demografico',
        allowedModule: '',
      },
      {
        page: 'Mapa',
        description: 'Mapa com as lojas e clientes',
        route: '/clientes/mapa',
        permission: 'clientes/mapa',
        allowedModule: '',
      },
      {
        page: 'Retenção',
        description: 'Retenção de clientes a partir da primeira compra',
        route: '/clientes/retencao',
        permission: 'clientes/retencao',
        allowedModule: '',
      },
      {
        page: 'Interesses',
        description: 'Venda das categorias dividida por genêro, idade e pessoa',
        route: '/clientes/interesses',
        permission: ['clientes/interesses/genero', 'clientes/interesses/idade', 'clientes/interesses/pessoa_juridica'],
        allowedModule: 'uncategorized_products',
        franchiseVerification: true,
      },
      {
        page: 'Melhores clientes',
        description: 'Ranking dos melhores clientes',
        route: '/clientes/melhores-clientes',
        permission: 'clientes/melhores_clientes',
        allowedModule: '',
        hasPiiAccessVerification: true,
      },
      {
        page: 'Busca de cliente',
        description: 'Busca com redirecionamento para "Detalhes do cliente"',
        route: '/clientes/busca-cliente',
        permission: 'clientes/busca_cliente',
        allowedModule: '',
        hasPiiAccessVerification: true,
      },
      {
        page: 'Gerenciamento de clientes',
        description: 'Edição do cadastro e solicitações de exclusão de dados',
        route: '/clientes/gerenciamento/cadastros',
        permission: ['clientes/gerenciamento/cadastros/visualizar-cadastros', 'clientes/gerenciamento/solicitacoes'],
        allowedModule: '',
        hasPiiAccessVerification: true,
      },
      {
        page: 'Classificação RFV',
        description: 'Análise dos grupos RFV (Recência, Frequência e Valor)',
        route: '/clientes/classificacao-rfv',
        permission: 'clientes/rfv',
        allowedModule: 'rfv',
      },
      {
        page: 'Consultar ofertas',
        description: 'Consulta de ofertas por CPF/CNPJ',
        route: '/clientes/consultar-ofertas',
        permission: 'clientes/consultar-ofertas',
        allowedModule: ['offer_management', 'industry'],
        isAlternative: true,
      },
    ],
  },
  produtos: {
    name: 'Produtos',
    icon: 'sell',
    parentPermission: 'produtos',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Busca de produto',
        description: 'Busca com redirecionamento para "Detalhes do produto"',
        route: '/produtos/busca-produto',
        permission: 'produtos/busca_produto',
        allowedModule: '',
      },
      {
        page: 'Ranking de produtos',
        description: 'Ranking dos produtos mais vendidos',
        route: '/produtos/ranking-produtos',
        permission: 'produtos/ranking_produtos',
        allowedModule: '',
      },
      {
        page: 'Árvore de produtos',
        description: 'Organização em árvore dos produtos e categorias',
        route: '/produtos/arvore-produtos',
        permission: 'produtos/arvore_produtos',
        allowedModule: 'products_tree',
        franchiseVerification: true,
      },
      {
        page: 'Comparativo de produtos',
        description: 'Comparativo de venda de produtos em diferentes períodos',
        route: '/produtos/comparativo-produtos',
        permission: 'produtos/comparativo_produtos',
        allowedModule: '',
      },
      {
        page: 'Comparativo de categorias',
        description: 'Comparativo de categorias em diferentes períodos',
        route: '/produtos/comparativo-categorias',
        permission: 'produtos/comparativo_categorias',
        allowedModule: 'products_tree',
        franchiseVerification: true,
      },
      {
        page: 'Gerenciamento de produtos',
        description: 'Cadastro e edição de produtos',
        route: '/produtos/gerenciamento-produtos',
        permission: 'produtos/gerenciamento_produtos',
        allowedModule: '',
      },
      {
        page: 'Faixas de preços',
        description: 'Análise de produtos separados por faixas de preço',
        route: '/produtos/faixas-precos',
        permission: 'produtos/faixas_precos',
        allowedModule: '',
      },
    ],
  },
  pedidos: {
    name: 'Pedidos',
    icon: 'shopping_cart',
    parentPermission: 'pedidos',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Controle de pedidos',
        description: 'Acompanhamento de pedidos do televendas',
        route: '/pedidos/controle-pedidos',
        permission: 'pedidos/controle-pedidos',
        allowedModule: 'telesales',
        franchiseVerification: true,
        franchiseeVerification: true,
        hasPiiAccessVerification: true,
      },
      {
        page: 'Gerenciamento de preços',
        description: 'Gerenciamento de preços de produtos do televendas',
        route: '/pedidos/gerenciamento-preco',
        permission: 'pedidos/gerenciamento-preco',
        allowedModule: 'telesales',
        franchiseVerification: true,
        franchiseeVerification: true,
      },
    ],
  },
  aplicativo: {
    name: 'Aplicativo',
    icon: 'smartphone',
    parentPermission: 'mobile',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Desempenho',
        description: 'Métricas de cadastro e utilização do app',
        route: '/mobile/desempenho',
        permission: 'mobile/desempenho',
        allowedModule: 'mobile',
      },
      {
        page: 'Banners',
        description: 'Configuração de campanhas de Banner',
        route: '/mobile/banners',
        permission: 'mobile/banners',
        allowedModule: 'mobile',
      },
      {
        page: 'Ofertas do aplicativo',
        description: 'Produtos em oferta exibidos no app',
        route: '/mobile/ofertas',
        permission: ['mobile/ofertas/produtos/edicao'],
        allowedModule: 'mobile',
      },
      {
        page: 'Pontos',
        description: 'Configuração de campanhas de voucher de pontos',
        route: '/mobile/pontos',
        permission: 'mobile/pontos',
        allowedModule: ['mobile', 'points'],
        franchiseeVerification: true,
      },
      {
        page: 'Cashback',
        description: 'Análise da distribuição e consumo do cashback',
        route: '/mobile/cashback',
        permission: 'mobile/cashback/cashback',
        allowedModule: ['mobile', 'cashback'],
      },
      {
        page: 'Encartes',
        description: 'Configuração dos encartes exibidos no app',
        route: '/mobile/encartes',
        permission: 'mobile/encartes',
        allowedModule: ['mobile', 'chatbot'],
      },
      {
        page: 'Sorteios',
        description: 'Configuração de campanhas de sorteio',
        route: '/mobile/sorteios',
        permission: 'mobile/sorteio',
        allowedModule: ['mobile', 'raffle'],
      },
      {
        page: 'Destaques',
        description: 'Configuração de destaques do app',
        route: '/mobile/destaques',
        permission: 'mobile/destaques',
        allowedModule: '',
      },
    ],
  },
  campanhas: {
    name: 'Campanhas',
    icon: 'flash_on',
    parentPermission: 'campanhas',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Calendário promocional',
        description: 'Calendário com as campanhas de comunicação',
        route: '/campanhas/calendario-promocional',
        permission: 'campanhas/calendario_promocional',
        allowedModule: '',
      },
      {
        page: 'Resultados gerais',
        description: 'Resultados gerais das campanhas de comunicação',
        route: '/campanhas/resultados-gerais',
        permission: 'campanhas/resultados_gerais',
        allowedModule: '',
      },
      {
        page: 'Gestão de ofertas',
        description: 'Configuração e histórico das ofertas de produtos',
        route: '/campanhas/gestao-ofertas',
        permission: 'campanhas/gestao_ofertas/ofertas',
        allowedModule: 'offer_management',
      },
      {
        page: 'Whatsapp',
        description: 'Configuração de campanhas de Whatsapp',
        route: '/campanhas/whatsapp',
        permission: 'campanhas/whatsapp',
        allowedModule: 'whatsapp',
      },
      {
        page: 'SMS',
        description: 'Configuração de campanhas de SMS',
        route: '/campanhas/sms',
        permission: 'campanhas/sms',
        allowedModule: '',
      },
      {
        page: 'Aplicativo',
        description: 'Configuração de campanhas de notificação push do app',
        route: '/campanhas/aplicativo',
        permission: 'campanhas/aplicativo',
        allowedModule: 'push',
      },
      {
        page: 'Resultados de encarte',
        description: 'Comparativo de produtos do encarte x venda geral',
        route: '/campanhas/resultados-encarte',
        permission: 'campanhas/resultados_encarte',
        allowedModule: '',
      },
      {
        page: 'E-mail',
        description: 'Configuração de campanhas de e-mail',
        route: '/campanhas/email',
        permission: 'campanhas/email-v2',
        allowedModule: 'email_v2',
      },
      {
        page: 'Cupom de desconto',
        description: 'Configuração de campanhas de cupom de desconto',
        route: '/campanhas/cupom-desconto',
        permission: 'campanhas/cupom_desconto',
        allowedModule: 'discount_coupon',
      },
    ],
  },
  gerenciadorDeAnalises: {
    name: 'Gerenciador de Análises',
    icon: 'article',
    parentPermission: '',
    onlyMercapromo: true,
    pages: [
      {
        page: '',
        description: 'Gere análises estratégicas e personalizadas',
        route: '/gerenciador-analises',
        permission: ['clientes/rfv', 'empresa/faturamento_incremental'],
        allowedModule: ['rfv', 'offer_management'],
      },
    ],
  },
  configuracoes: {
    name: 'Configurações',
    icon: 'settings',
    parentPermission: 'configuracoes',
    onlyMercapromo: true,
    pages: [
      {
        page: 'Lojas',
        description: 'Configurações de lojas e grupos de precificação',
        route: '/configuracoes/units',
        permission: 'configuracoes/lojas',
        allowedModule: '',
      },
      {
        page: 'Gerais',
        description: 'Configurações gerais da plataforma',
        route: '/configuracoes/gerais',
        permission: 'configuracoes/gerais',
        allowedModule: '',
        franchiseeVerification: true,
      },
      {
        page: 'Redes sociais',
        description: 'Redes sociais exibidas no site de cadastro e aplicativo',
        route: '/configuracoes/redes-sociais',
        permission: 'configuracoes/redes-sociais',
        allowedModule: ['mobile', 'hotsite'],
        franchiseeVerification: true,
      },
      {
        page: 'Site de cadastramento',
        description: 'Configurações sobre o site de cadastramento',
        route: '/configuracoes/site-cadastramento',
        permission: 'configuracoes/site-cadastramento',
        allowedModule: '',
        franchiseeVerification: true,
      },
      {
        page: 'Mensagens',
        description: 'Modelos de mensagem para campanhas de comunicação',
        route: '/configuracoes/mensagens',
        permission: 'configuracoes/mensagens',
        allowedModule: '',
      },
      {
        page: 'Permissionamento do filiado',
        description: 'Configurações de permissões de filiados',
        route: '/configuracoes/permissionamento-filiado',
        permission: 'configuracoes/permissionamento-filiado',
        allowedModule: '',
      },
    ],
  },
}
